import { FiltersNegociosDialogComponent } from '../components/negocios/negocios/filters-negocios-dialog.component';
import { FiltersPreciosDialogComponent} from '../components/precios-seccion/precios/filters-precios-dialog.component';
import { NewEtiquetaComponent } from '../components/cuentas/new-etiqueta';
import { NewCuentaDialogComponent } from '../components/cuentas/new-cuenta-dialog';
import { Observable } from 'rxjs/Rx';
import { TextDialogComponent } from '../components/common/dialog/text-dialog/text-dialog.component';
import { TextAreaDialogComponent } from '../components/common/dialog/text-area-dialog/text-area-dialog.component';
import { NewConsignaDialogComponent } from '../components/agenda/new-consigna-dialog/new-consigna-dialog.component';
import { NewContactoDialogComponent } from '../components/cuentas/new-contacto-dialog/new-contacto-dialog.component';
import { NewColaboradorDialogComponent } from '../components/colaboradores/new-colaborador-dialog/new-colaborador-dialog.component';
import { NewNegocioDialogComponent } from '../components/negocios/new-negocio-dialog/new-negocio-dialog.component';
import { RateComponent } from './../components/common/dialog/rate/rate.component';
import { NewAcopioDialogComponent } from '../components/abm/new-acopio-dialog';
import { NewCategoriaDialogComponent } from '../components/abm/new-categoria-dialog';
import { ColaboradoresDialogComponent } from './../components/common/dialog/colaboradores-dialog';
import { ContactosDialogComponent } from './../components/common/dialog/contactos-dialog';
import { EmpresasDialogComponent } from './../components/common/dialog/empresas-dialog';
import { PrecioEspecialDialogComponent } from './../components/negocios/negocios/precio-especial-dialog.component';
import { PrecioDialogComponent } from '../components/precios-seccion/precios/precio-dialog.component';
import { NewEditProductoDialogComponent } from './../components/abm/new-edit-producto-dialog/new-edit-producto-dialog.component';
import { NewComunicacionDialogComponent } from '../components/comunicaciones/new-comunicacion-dialog/new-comunicacion-dialog.component';
import { ExpandedChartDialogComponent } from '../components/negocios/tablero-negocios/expanded-chart-dialog/expanded-chart-dialog.component'
import { NumberEditDialogComponent } from '../components/common/dialog/number-edit-dialog';
import { NewEditMercadoDialogComponent } from '../components/abm/mercado/new-edit-mercado-dialog/new-edit-mercado-dialog.component';
import { DropdownDialogComponent } from '../components/common/dialog/dropdown-dialog/dropdown-dialog.component';
import { NewEntidadDialogComponent } from '../components/abm/entidades-financieras/new-entidad-dialog/new-entidad-dialog.component';
import { GenericFilterDialogComponent, FilterSettings } from '../components/common/dialog/generic-filter-dialog/generic-filter-dialog.component';
import { GenericTableDialogComponent, GenericTableDataSource } from '../components/common/dialog/generic-table-dialog';

import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';
import {PrecioDolarDetailDialogComponent} from '../components/precios-seccion/financiera/precio-dolar-detail-dialog/precio-dolar-detail-dialog.component';
import {
  PrecioPrintTitle,
  PreciosToImgDialogComponent
} from '../components/precios-seccion/precios-to-img-dialog/precios-to-img-dialog.component';
import {Grupo, PRECIO_PRINT_WIDTH} from '../components/precios-seccion/general-interfaces';
import {PrecioMonitor} from '@common/precio-monitor';
import * as moment from 'moment';
import { EditAcopioDialogComponent } from 'app/components/abm/edit-acopio-dialog/edit-acopio-dialog.component';
import {
  NegNewFiltersDialogComponent,
} from '../components/negocios/negocios/negocio-list/neg-new-filters-dialog/neg-new-filters-dialog.component';
import {GenericFilter} from '../components/negocios/negocios/negocio-filter';
import {
  NewNegocioResponsiveDialogComponent
} from '../components/negocios/new-negocio-responsive-dialog/new-negocio-responsive-dialog.component';

@Injectable()
export class DialogsService {

    constructor(private dialog: MdDialog) { }

    public showRateConsignaDialog(): Observable<number>{
      let dialogRef: MdDialogRef<RateComponent>;

      dialogRef = this.dialog.open(RateComponent);

      return dialogRef.afterClosed();
    }

    public confirm(title: string, message: string, positiveText: string = 'Ok', negativeText: string = 'Cancel', showNegativeButton = true): Observable<boolean> {

        let dialogRef: MdDialogRef<TextDialogComponent>;

        dialogRef = this.dialog.open(TextDialogComponent);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.positiveText = positiveText;
        dialogRef.componentInstance.negativeText = negativeText;
        dialogRef.componentInstance.showNegativeButton = showNegativeButton;

        return dialogRef.afterClosed();
    }

    public showTextAreaDialog(title: string, text: string, positiveText: string = 'Ok', negativeText: string = 'Cancel', requieredComment: boolean = false, textMaxLength = 100000): Observable<string> {
      let dialogRef: MdDialogRef<TextAreaDialogComponent>;

      let config = new MdDialogConfig();

      dialogRef = this.dialog.open(TextAreaDialogComponent, config);
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.text = text;
      dialogRef.componentInstance.positiveText = positiveText;
      dialogRef.componentInstance.negativeText = negativeText;
      dialogRef.componentInstance.requieredComment = requieredComment;
      dialogRef.componentInstance.textMaxLength = textMaxLength;

      return dialogRef.afterClosed();
    }

    public showEditConsignaDialog(consigna){
      let dialogRef: MdDialogRef<NewConsignaDialogComponent>;

      dialogRef = this.dialog.open(NewConsignaDialogComponent);
      dialogRef.componentInstance.title = 'Editar Consigna';
      dialogRef.componentInstance.positiveText = 'GUARDAR';
      dialogRef.componentInstance.negativeText = 'CANCELAR';
      dialogRef.componentInstance.otherOptionsText = 'MÁS OPCIONES';

      dialogRef.componentInstance.consigna = consigna;

      return dialogRef.afterClosed();
    }

    public showNewConsignaDialog(title: string,
                      positiveText: string = 'ACEPTAR',
                      negativeText: string = 'CANCELAR',
                      otherOptionsText: string = 'MÁS OPCIONES',
                      colaborador?,
                      cuenta?,
                      contacto?,
                      defaultDate?): Observable<string> {
      let dialogRef: MdDialogRef<NewConsignaDialogComponent>;

      dialogRef = this.dialog.open(NewConsignaDialogComponent);
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.positiveText = positiveText;
      dialogRef.componentInstance.negativeText = negativeText;
      dialogRef.componentInstance.otherOptionsText = otherOptionsText;

      if (colaborador){
        dialogRef.componentInstance.colaboradorAutocompleteComponent.colaboradores.push(colaborador);
      }

      if(cuenta){
        dialogRef.componentInstance.cuentaEtiquetaAutocompleteComponent.selectedCuentas.push(cuenta);
      }

      if(contacto){
        dialogRef.componentInstance.cuentaEtiquetaAutocompleteComponent.selectedContactos.push(contacto);
      }

      if (defaultDate) {
        dialogRef.componentInstance.startDate = defaultDate;
        dialogRef.componentInstance.endDate = defaultDate;
      }

      return dialogRef.afterClosed();
    }

    public showNewColaboradorDialog(colaborador = null,
                      positiveText: string = 'ACEPTAR',
                      negativeText: string = 'CANCELAR')
                      : Observable<any> {
      let dialogRef: MdDialogRef<NewColaboradorDialogComponent>;

      dialogRef = this.dialog.open(NewColaboradorDialogComponent);
      dialogRef.componentInstance.title = colaborador ? 'Editar Colaborador' : 'Nuevo Colaborador';
      dialogRef.componentInstance.colaborador = colaborador;
      dialogRef.componentInstance.positiveText = positiveText;
      dialogRef.componentInstance.negativeText = negativeText;

      return dialogRef.afterClosed();
    }

    public showNewCuentaDialog(
      cuenta,
      positiveText: string = 'Ok',
      negativeText: string = 'Cancelar',
      type?: number
    ): Observable<string> {
      let dialogRef: MdDialogRef<NewCuentaDialogComponent>;

      dialogRef = this.dialog.open(NewCuentaDialogComponent);
      dialogRef.componentInstance.title = cuenta ? 'Editar Cuenta' : 'Nueva Cuenta';
      dialogRef.componentInstance.cuenta = cuenta;
      dialogRef.componentInstance.type = type;
      dialogRef.componentInstance.positiveText = positiveText;
      dialogRef.componentInstance.negativeText = negativeText;

      return dialogRef.afterClosed();
    }

    public showNewContactoDialog(
      cuentaId: string,
      contacto,
      positiveText: string = 'Ok',
      negativeText: string = 'Cancelar'
    ): Observable<string> {
      let dialogRef: MdDialogRef<NewContactoDialogComponent>;

      dialogRef = this.dialog.open(NewContactoDialogComponent);
      dialogRef.componentInstance.title = contacto ? 'Editar Contacto' : 'Nuevo Contacto';
      dialogRef.componentInstance.contacto = contacto;
      dialogRef.componentInstance.positiveText = positiveText;
      dialogRef.componentInstance.negativeText = negativeText;
      dialogRef.componentInstance.cuentaId = cuentaId;

      return dialogRef.afterClosed();
    }

    public showNewEtiquetaDialog(
      cuenta
    ): Observable<string> {
      let dialogRef: MdDialogRef<NewEtiquetaComponent>;

      dialogRef = this.dialog.open(NewEtiquetaComponent);
      dialogRef.componentInstance.cuenta = cuenta;

      return dialogRef.afterClosed();
    }

    public showNewAcopioDialog(): Observable<string> {
      let dialogRef: MdDialogRef<NewAcopioDialogComponent>;

      dialogRef = this.dialog.open(NewAcopioDialogComponent);

      return dialogRef.afterClosed();
    }

    public editAcopioDialog(acopio): Observable<string> {
      let dialogRef: MdDialogRef<EditAcopioDialogComponent>;

      dialogRef = this.dialog.open(EditAcopioDialogComponent);
      dialogRef.componentInstance.acopio = acopio;
      return dialogRef.afterClosed();
    }

    public showNewCategoriaDialog(): Observable<string> {
      let dialogRef: MdDialogRef<NewCategoriaDialogComponent>;

      dialogRef = this.dialog.open(NewCategoriaDialogComponent);

      return dialogRef.afterClosed();
    }

    public showNewProductoDialog(productosList: any): Observable<string> {
      let dialogRef: MdDialogRef<NewEditProductoDialogComponent>;

      dialogRef = this.dialog.open(NewEditProductoDialogComponent);
      dialogRef.componentInstance.isNewProducto = true;
      dialogRef.componentInstance.productosList = productosList;

      return dialogRef.afterClosed();
    }

    public showEditProductoDialog(selectedProducto: any, productosList: any): Observable<string> {

      let dialogRef: MdDialogRef<NewEditProductoDialogComponent>;
      dialogRef = this.dialog.open(NewEditProductoDialogComponent);
      if (selectedProducto === true) {
        dialogRef.componentInstance.isNewProducto = true;
      } else {
        dialogRef.componentInstance.isNewProducto = false;
      }
      dialogRef.componentInstance.currentProducto = selectedProducto;
      dialogRef.componentInstance.productosList = productosList;

      return dialogRef.afterClosed();
    }

    public showColaboradoresDialog(): Observable<string> {
      let dialogRef: MdDialogRef<ColaboradoresDialogComponent>;

      dialogRef = this.dialog.open(ColaboradoresDialogComponent);

      return dialogRef.afterClosed();
    }

    public showContactosDialog(): Observable<string> {
      let dialogRef: MdDialogRef<ContactosDialogComponent>;

      dialogRef = this.dialog.open(ContactosDialogComponent);

      return dialogRef.afterClosed();
    }

    public showEmpresasDialog(): Observable<string> {
      let dialogRef: MdDialogRef<EmpresasDialogComponent>;

      dialogRef = this.dialog.open(EmpresasDialogComponent);

      return dialogRef.afterClosed();
    }

    public showNegociosFilterDialog(column: string, title: string, filters: any): Observable<number>{
      let dialogRef: MdDialogRef<FiltersNegociosDialogComponent>;

      let config = new MdDialogConfig();
      config.width = '400px';
      if (column === 'hora') {
        config.width = '430px';
      }

      dialogRef = this.dialog.open(FiltersNegociosDialogComponent, config);
      dialogRef.componentInstance.column = column;
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.filters = JSON.parse(JSON.stringify(filters));

      return dialogRef.afterClosed();
    }

    public showNewNegocioDialog(negocioId, isDuplicate: boolean = false, selectedCuenta?, fromPrecio = null): Observable<string> {
      let dialogRef: MdDialogRef<NewNegocioDialogComponent>;

      let config = new MdDialogConfig();
      // config.height = '560px';
      config.panelClass = 'new-negocio-panel-container';

      dialogRef = this.dialog.open(NewNegocioDialogComponent, config);
      dialogRef.componentInstance.title = negocioId && !isDuplicate ? 'Editar Negocio' : 'Nuevo Negocio';
      dialogRef.componentInstance.id = negocioId;
      dialogRef.componentInstance.isDuplicate = isDuplicate;
      dialogRef.componentInstance.selectedCuenta = selectedCuenta;
      dialogRef.componentInstance.fromPrecio = fromPrecio;

      return dialogRef.afterClosed();
    }

    public showNewNegocioResponsiveDialog(isClone: boolean = false, isEdit: boolean = false, idNegocio: number = 0, fromPrecio: PrecioMonitor | null = null) {
      const data = {isClone, isEdit, idNegocio, fromPrecio};
      const config = new MdDialogConfig();
      config.disableClose = true;
      config.panelClass = 'new-negocio-responsive-panel';
      config.data = data;
      return this.dialog.open(NewNegocioResponsiveDialogComponent, config).afterClosed();
    }

    public showPreciosFilterDialog(column: string, title: string, filters: any): Observable<number>{
      let dialogRef: MdDialogRef<FiltersPreciosDialogComponent>;

      let config = new MdDialogConfig();
      config.width = '400px';

      dialogRef = this.dialog.open(FiltersPreciosDialogComponent, config);
      dialogRef.componentInstance.column = column;
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.filters = JSON.parse(JSON.stringify(filters));

      return dialogRef.afterClosed();
    }

    public showPrecioDetailDialog(responsable, fecha, validador, isPizarraView, fechaPublicacion = '', producto = '', titulo = null, mercado =''): Observable<number>{
      let dialogRef: MdDialogRef<PrecioDialogComponent>;

      let config = new MdDialogConfig();
      config.width = '320px';

      dialogRef = this.dialog.open(PrecioDialogComponent, config);
      dialogRef.componentInstance.responsable = responsable;
      dialogRef.componentInstance.fecha = fecha;
      dialogRef.componentInstance.validador = validador;
      dialogRef.componentInstance.isPizarraView = isPizarraView;
      dialogRef.componentInstance.producto = producto;
      dialogRef.componentInstance.fechaPublicacion = fechaPublicacion;
      dialogRef.componentInstance.titulo = titulo;
      dialogRef.componentInstance.mercado = mercado;

      return dialogRef.afterClosed();
    }

    public showPrecioEspecialDialog(data: any, crear: boolean): Observable<number>{
      let dialogRef: MdDialogRef<PrecioEspecialDialogComponent>;

      let config = new MdDialogConfig();
      config.width = '330px';

      dialogRef = this.dialog.open(PrecioEspecialDialogComponent, config);
      dialogRef.componentInstance.data = data;
      dialogRef.componentInstance.crear = crear;

      return dialogRef.afterClosed();
    }

    public showNewComunicacionDialog(comunicacion, dialogState): Observable<number> {
      let dialogRef: MdDialogRef<NewComunicacionDialogComponent>;

      const config = new MdDialogConfig();
      config.width = '600px';

      dialogRef = this.dialog.open(NewComunicacionDialogComponent, config);
      dialogRef.componentInstance.comunicacion = comunicacion;
      dialogRef.componentInstance.dialogState = dialogState;
      return dialogRef.afterClosed();
    }

  public showExpandedChartDialog(chart, filter, chartIsVertical): Observable<number> {
    let dialogRef: MdDialogRef<ExpandedChartDialogComponent>;

    const config = new MdDialogConfig();
    // config.width = '1000px';
    dialogRef = this.dialog.open(ExpandedChartDialogComponent, config);
    dialogRef.componentInstance.chart = chart;
    dialogRef.componentInstance.filter = filter;
    dialogRef.componentInstance.chartIsVertical = chartIsVertical;

    return dialogRef.afterClosed();
  }


  public showEditNumberDialog(title, previousNumber = 0, allowZero = true, allowNegative = true, placeholder = 'Número'): Observable<number> {
    let dialogRef: MdDialogRef<NumberEditDialogComponent>;

    const config = new MdDialogConfig();
    config.width = '375px';
    dialogRef = this.dialog.open(NumberEditDialogComponent, config);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.numberToReturn = previousNumber;
    dialogRef.componentInstance.allowZero = allowZero;
    dialogRef.componentInstance.allowNegative = allowNegative;
    dialogRef.componentInstance.inputPlaceholder = placeholder;

    return dialogRef.afterClosed();
  }

  public showGenericFilterDialog(filterSettings): Observable<any> {
    let dialogRef: MdDialogRef<GenericFilterDialogComponent>;

    const config = new MdDialogConfig();
	config.width = '400px';
    dialogRef = this.dialog.open(GenericFilterDialogComponent, config);
    dialogRef.componentInstance.filterSettings = filterSettings;

	return dialogRef.afterClosed();
  }

  public showNewEditEntidadDialog(codigosEntidad: string[], entidad = null): Observable<number> {
    let dialogRef: MdDialogRef<NewEntidadDialogComponent>;

    const config = new MdDialogConfig();
    config.width = '1000px';
    config.panelClass = 'new-entidad-dialog-panel';
    dialogRef = this.dialog.open(NewEntidadDialogComponent, config);
    dialogRef.componentInstance.entidad = entidad;
    dialogRef.componentInstance.entityCodes = codigosEntidad;

	return dialogRef.afterClosed();
  }

  public showNewEditMercadoDialog(codigos , mercado = null): Observable<boolean> {
    let dialogRef: MdDialogRef<NewEditMercadoDialogComponent>;

    const config = new MdDialogConfig();
    config.width = '650px';
    dialogRef = this.dialog.open(NewEditMercadoDialogComponent, config);
    dialogRef.componentInstance.mercadoCodigos = codigos;
    dialogRef.componentInstance.mercado = mercado;

    return dialogRef.afterClosed();
  }

  public showDropdownDialog(title, valueSelected = 0, options = []): Observable<number> {
    let dialogRef: MdDialogRef<DropdownDialogComponent>;

    const config = new MdDialogConfig();
    config.width = '375px';
    dialogRef = this.dialog.open(DropdownDialogComponent, config);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.valueSelected = valueSelected;
    dialogRef.componentInstance.options = options;

	return dialogRef.afterClosed();
  }

  public showPrecioDolarDescripcion(titulo, descripcion, responsable, validador, fecha) {
    let dialogRef: MdDialogRef<PrecioDolarDetailDialogComponent>;
    const config = new MdDialogConfig();
    config.width = '250px';
    dialogRef = this.dialog.open(PrecioDolarDetailDialogComponent, config);
    dialogRef.componentInstance.titulo = titulo;
    dialogRef.componentInstance.desc = descripcion;
    dialogRef.componentInstance.responsable = responsable;
    dialogRef.componentInstance.validador = validador;
    dialogRef.componentInstance.fecha = fecha;
  }

  imprimirPreciosPNG(titulo: PrecioPrintTitle, fecha: Date, preciosRAW: PrecioMonitor[]) {

    const grupos: Grupo[] = [];
    // creamos un array de nombres de grupo
    const gruposNombres = Array.from(new Set(preciosRAW.map(x => x.Grupo)))
    gruposNombres.forEach(nomGrupo => {
      const precios = preciosRAW.filter(x => x.Grupo === nomGrupo);
      grupos.push({Grupo: nomGrupo, Precios: precios});
    });

    const dialogConfig = new MdDialogConfig();
    dialogConfig.width = PRECIO_PRINT_WIDTH;
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'dialog-pannel-custom';
    const dialogRef = this.dialog.open(PreciosToImgDialogComponent);
    dialogRef.componentInstance.titulo = titulo;
    dialogRef.componentInstance.DATA = grupos;
    dialogRef.componentInstance.date = moment(fecha).format('DD/MM/YYYY');
    return dialogRef;
  }

  openNewNegFilterDialog(column: string, filter: GenericFilter) {
    const dialogConfig = new MdDialogConfig();
    dialogConfig.panelClass = 'dialog-pannel-mobile';
    dialogConfig.data = {
      column: column,
      type: filter.type,
      data: filter.data,
    };
    return this.dialog.open(NegNewFiltersDialogComponent, dialogConfig).afterClosed();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/dialogs-service.ts